import React from 'react';
import InfoIcon from '@material-ui/icons/Info';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  container: {
    boxSizing:"border-box",
    border: `1px solid ${theme.warningColor}`,
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    margin: '14px 0',
    padding: '4px 10px',
    width: 'fit-content',
    color: theme.gridTextColor,
    borderRadius: 4
  },
  warningIcon: {
    color: theme.warningColor
  }
});

const ValidationReason = ({ classes, message }) => {
  return (
    <div className={classes.container}>
      <div className={classes.warningIcon}>
        <InfoIcon />
      </div>
      <div>{message}</div>
    </div>
  );
};

export default withStyles(styles)(ValidationReason);
